(function () {
  function isMobile() { return window.matchMedia('(max-width:760px)').matches; }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-shelf-item]');
    if (item) {
      if (!isMobile()) return;
      e.preventDefault();
      var shelf = item.closest('[data-shelf]');
      if (!shelf) return;
      var key = item.getAttribute('data-shelf-item');
      shelf.querySelectorAll('[data-shelf-item]').forEach(function (b) {
        b.setAttribute('aria-selected', b === item ? 'true' : 'false');
      });
      shelf.querySelectorAll('[data-shelf-pane]').forEach(function (p) {
        p.hidden = p.getAttribute('data-shelf-pane') !== key;
      });
      return;
    }
    var nav = e.target.closest('[data-shelf-nav]');
    if (nav) {
      var shelfEl = nav.closest('[data-shelf]');
      if (!shelfEl) return;
      var items = Array.prototype.slice.call(shelfEl.querySelectorAll('[data-shelf-item]'));
      var idx = items.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
      var dir = Number(nav.getAttribute('data-shelf-nav')) || 1;
      var nextIdx = (idx + dir + items.length) % items.length;
      items[nextIdx].click();
    }
  });

  function stepShelf(shelf, dir) {
    var items = Array.prototype.slice.call(shelf.querySelectorAll('[data-shelf-item]'));
    if (!items.length) return;
    var idx = items.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
    var nextIdx = (idx + dir + items.length) % items.length;
    items[nextIdx].click();
  }

  document.querySelectorAll('[data-shelf-rail]').forEach(function (rail) {
    var x0 = null;
    rail.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    rail.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) {
        var shelf = rail.closest('[data-shelf]');
        if (shelf) stepShelf(shelf, dx < 0 ? 1 : -1);
      }
      x0 = null;
    });
  });
})();
